import type { JobType } from '@/enum'
import type { ITaskTemplate, ITaskTemplateSection } from '@/interfaces'
import type { IDocument } from '@/interfaces/IDocument'
import Base from '@/models/Base'
import DocumentModel from '@/models/DocumentModel'
import TaskTemplateSection from '@/models/task-templates/TaskTemplateSection'

class TaskTemplate extends Base implements ITaskTemplate {
  title: string

  description: string

  type: JobType

  employeesCount: number | null

  sections: ITaskTemplateSection[]

  documents: IDocument[]

  constructor(taskTemplate?: any) {
    super(taskTemplate)

    this.title = taskTemplate?.title ?? ''
    this.description = taskTemplate?.description ?? ''
    this.type = taskTemplate?.type ?? null
    this.employeesCount = taskTemplate?.employeesCount ?? 1
    this.sections = taskTemplate?.sections?.map((section: any) => new TaskTemplateSection(section, true)) ?? []
    this.documents = taskTemplate?.documents?.map((document: any) => new DocumentModel(document)) ?? []
  }
}

export default TaskTemplate
